import VirtualRenderer from 'net.akehurst.language.editor-kotlin-ace-loader!?id=ace/virtual_renderer&name=VirtualRenderer';
import Ace from 'ace-builds/src-noconflict/ace.js';
import Editor from 'net.akehurst.language.editor-kotlin-ace-loader!?id=ace/editor&name=Editor';
import * as $module$monaco_editor_esm_vs_editor_editor_api_js_y9u958 from 'monaco-editor/esm/vs/editor/editor.api.js';
import Range from 'net.akehurst.language.editor-kotlin-ace-loader!?id=ace/range&name=Range';
import {
  m6 as objectMeta,
  ga as VOID,
  o6 as setMetadataFor,
  k9 as IllegalStateException,
  r6 as toString,
  ba as printStackTrace,
  a1 as Unit_getInstance,
  p5 as classMeta,
  t9 as THROW_ISE,
  g9 as Enum,
  y9 as ensureNotNull,
  s9 as THROW_CCE,
  ha as asList,
  a2 as collectionSizeOrDefault,
  d3 as mapCapacity,
  u6 as coerceAtLeast,
  j1 as LinkedHashMap,
  aa as noWhenBranchMatchedException,
  q9 as Pair,
  l1 as List,
  e6 as isInterface,
  n2 as first,
  a as getKClassFromExpression,
  s2 as joinToString,
  m1 as Entry,
  f2 as copyToArray,
  e1 as ArrayList,
  s5 as equals,
  b3 as listOf,
  h2 as emptyList,
  ea as toString_0,
  t1 as Set,
  a6 as isArray,
  f1 as Collection,
  x as Companion_getInstance,
  d5 as CoroutineImpl,
  p4 as get_COROUTINE_SUSPENDED,
} from './kotlin-kotlin-stdlib.mjs';
import {
  f as LogLevel_Error_getInstance,
  e as LogLevel_Debug_getInstance,
  h as LogLevel_Information_getInstance,
  m as AglEditor,
  i as LogLevel_None_getInstance,
  g as LogLevel_Fatal_getInstance,
  k as LogLevel_Warning_getInstance,
  j as LogLevel_Trace_getInstance,
  d as LogLevel_All_getInstance,
  n as valueOf,
} from './net.akehurst.language.editor-agl-editor-api.mjs';
import {
  h as Agl_getInstance,
  r1 as ContextFromGrammar,
  c3 as ContextFromTypeModel,
  f as TypeModelFromGrammar_getInstance,
  p5 as GrammarTypeNamespace,
  o3 as AsmElementReference,
  q3 as AsmElementSimple,
  n3 as AsmElementProperty,
  u3 as AsmSimple,
  d3 as ContextSimple,
  g as Companion_getInstance_0,
} from './net.akehurst.language-agl-processor.mjs';
import {
  a as Companion_getInstance_1,
  c as TreeViewFunctions,
  b as Companion_getInstance_2,
} from './net.akehurst.language.editor.browser.demo-technology-gui-widgets.mjs';
import { a as create } from './net.akehurst.kotlin.html5-html-builder.mjs';
import {
  i as SupervisorJob,
  e as CoroutineScope,
} from './kotlinx.coroutines-kotlinx-coroutines-core-js-ir.mjs';
import {
  a as asyncImmediately,
  b as localVfs,
} from './korge-root-korio.mjs';
import {
  b as attachToAce,
  a as IAce,
} from './net.akehurst.language.editor-agl-editor-browser-ace.mjs';
import {
  b as attachToMonaco,
  a as Monaco,
} from './net.akehurst.language.editor-agl-editor-browser-monaco.mjs';
import { a as attachToCodeMirror } from './net.akehurst.language.editor-agl-editor-browser-codemirror.mjs';
import { a as attachToAglEditor } from './net.akehurst.language.editor-agl-editor-browser-agl.mjs';
import {
  c as Datatypes_getInstance,
  l as Examples_getInstance,
  f as KerML_Std_getInstance,
  h as SQL_getInstance,
  d as GraphvizDot_getInstance,
  i as SText_getInstance,
  e as Java8_getInstance,
  j as TraceabilityQuery_getInstance,
  g as MScript_getInstance,
  k as Xml_getInstance,
  b as AglStyle_getInstance,
  a as AglGrammar_getInstance,
} from './net.akehurst.language.editor.browser.demo-information-editor.mjs';
import {
  l as PropertyDeclaration,
  i as DataType,
  p as TypeNamespace,
  o as TypeModel,
  m as StructuredType,
  n as TupleType,
} from './net.akehurst.language-type-model.mjs';
//region block: imports
var create_0 = $module$monaco_editor_esm_vs_editor_editor_api_js_y9u958.editor.create;
var defineTheme = $module$monaco_editor_esm_vs_editor_editor_api_js_y9u958.editor.defineTheme;
var setModelMarkers = $module$monaco_editor_esm_vs_editor_editor_api_js_y9u958.editor.setModelMarkers;
var setModelLanguage = $module$monaco_editor_esm_vs_editor_editor_api_js_y9u958.editor.setModelLanguage;
var setTheme = $module$monaco_editor_esm_vs_editor_editor_api_js_y9u958.editor.setTheme;
//endregion
//region block: pre-declaration
class BuildConfig {
  constructor() {
    BuildConfig_instance = this;
    this.w52_1 = '1.9.20-Beta';
    this.x52_1 = '2023-09-29T14:14:51.325469Z[UTC]';
    this.y52_1 = '2023-Sept-29';
    this.z52_1 = '14:14:51 UTC';
    this.a53_1 = '0.20.0';
    this.b53_1 = '1.24.2';
  }
}
class DemoLogger {
  constructor(level) {
    this.c53_1 = level;
  }
  d53(msg) {
    return this.e53(LogLevel_Error_getInstance(), msg, null);
  }
  f53(msg) {
    return this.e53(LogLevel_Debug_getInstance(), msg, null);
  }
  e53(lvl, msg, t) {
    if (lvl.cc(this.c53_1) <= 0) {
      logAll(this, lvl, msg, t);
    } else
    ;
  }
}
class AlternativeEditors extends Enum {}
class Constants {
  constructor() {
    Constants_instance = this;
    this.g53_1 = 'editor-sentence';
    this.h53_1 = 'editor-grammar';
    this.i53_1 = 'editor-references';
    this.j53_1 = 'editor-style';
    this.k53_1 = 'editor-format';
    this.l53_1 = 'language-user';
    this.m53_1 = Agl_getInstance().registry.agl.grammarLanguageIdentity;
    this.n53_1 = Agl_getInstance().registry.agl.scopesLanguageIdentity;
    this.o53_1 = Agl_getInstance().registry.agl.styleLanguageIdentity;
    this.p53_1 = Agl_getInstance().registry.agl.formatLanguageIdentity;
  }
}
class Demo {
  constructor(editors, logger) {
    this.q53_1 = editors;
    this.r53_1 = logger;
    this.s53_1 = true;
    this.t53_1 = Companion_getInstance_2().h4c(document);
    var tmp = this;
    var tmp_0 = document.querySelector('select#example');
    tmp.u53_1 = tmp_0 instanceof HTMLElement ? tmp_0 : THROW_CCE();
    var tmp_1 = this;
    Constants_getInstance();
    var tmp_2 = ensureNotNull(this.q53_1.u3('editor-sentence'));
    tmp_1.v53_1 = isInterface(tmp_2, AglEditor) ? tmp_2 : THROW_CCE();
    var tmp_3 = this;
    Constants_getInstance();
    tmp_3.w53_1 = ensureNotNull(this.q53_1.u3('editor-grammar'));
    var tmp_4 = this;
    Constants_getInstance();
    var tmp_5 = ensureNotNull(this.q53_1.u3('editor-style'));
    tmp_4.x53_1 = isInterface(tmp_5, AglEditor) ? tmp_5 : THROW_CCE();
    var tmp_6 = this;
    Constants_getInstance();
    var tmp_7 = ensureNotNull(this.q53_1.u3('editor-references'));
    tmp_6.y53_1 = isInterface(tmp_7, AglEditor) ? tmp_7 : THROW_CCE();
  }
  a54() {
    connectEditors(this);
    connectTrees(this);
    configExampleSelector(this);
  }
  b54(eg) {
    this.s53_1 = false;
    this.w53_1.text = eg.l47_1;
    this.x53_1.text = eg.n47_1;
    this.y53_1.text = eg.m47_1;
    this.v53_1.doUpdate = false;
    this.v53_1.sentenceContext = new ContextSimple();
    this.v53_1.languageDefinition.update(this.w53_1.text, this.y53_1.text, this.x53_1.text);
    this.v53_1.text = eg.k47_1;
    this.v53_1.doUpdate = true;
    this.s53_1 = true;
  }
  z53() {
    // Inline function 'kotlin.collections.forEach' call
    var tmp0_forEach = this.q53_1.k3();
    var tmp0_iterator = tmp0_forEach.u();
    while (tmp0_iterator.h1()) {
      var element = tmp0_iterator.j1();
      // Inline function 'net.akehurst.language.editor.application.client.web.Demo.finalize.<anonymous>' call
      element.destroy();
    }
  }
}
class main$demoIf$1 {
  constructor($logger) {
    this.c54_1 = $logger;
  }
  d54() {
    return this.c54_1.c53_1;
  }
  e54(level) {
    this.c54_1.c53_1 = level;
  }
}
class initialiseExamples$slambda extends CoroutineImpl {
  r38($completion) {
    var tmp = this.x37($completion);
    tmp.pf_1 = Unit_getInstance();
    tmp.qf_1 = null;
    return tmp.ag();
  }
  y37($completion) {
    return this.r38($completion);
  }
  ag() {
    var suspendResult = this.pf_1;
    $sm: do
      try {
        var tmp = this.nf_1;
        switch (tmp) {
          case 0:
            this.of_1 = 4;
            this.n54_1 = localVfs(resourcesPath).f3e();
            Examples_getInstance().q47(Datatypes_getInstance().o48_1);
            this.o54_1 = Examples_getInstance();
            this.nf_1 = 1;
            suspendResult = KerML_Std_getInstance().g49(this.n54_1, this);
            if (suspendResult === get_COROUTINE_SUSPENDED()) {
              return suspendResult;
            }

            continue $sm;
          case 1:
            this.p54_1 = suspendResult;
            this.o54_1.q47(this.p54_1);
            Examples_getInstance().q47(SQL_getInstance().e4b_1);
            this.q54_1 = Examples_getInstance();
            this.nf_1 = 2;
            suspendResult = GraphvizDot_getInstance().g49(this.n54_1, this);
            if (suspendResult === get_COROUTINE_SUSPENDED()) {
              return suspendResult;
            }

            continue $sm;
          case 2:
            this.r54_1 = suspendResult;
            this.q54_1.q47(this.r54_1);
            Examples_getInstance().q47(SText_getInstance().m4b_1);
            Examples_getInstance().q47(Java8_getInstance().o49_1);
            Examples_getInstance().q47(TraceabilityQuery_getInstance().u4b_1);
            this.s54_1 = Examples_getInstance();
            this.nf_1 = 3;
            suspendResult = MScript_getInstance().g49(this.n54_1, this);
            if (suspendResult === get_COROUTINE_SUSPENDED()) {
              return suspendResult;
            }

            continue $sm;
          case 3:
            var ARGUMENT = suspendResult;
            this.s54_1.q47(ARGUMENT);
            Examples_getInstance().q47(Xml_getInstance().c4c_1);
            Examples_getInstance().q47(AglStyle_getInstance().g48_1);
            Examples_getInstance().q47(AglGrammar_getInstance().y47_1);
            return Unit_getInstance();
          case 4:
            throw this.qf_1;
        }
      } catch ($p) {
        var e = $p;
        if (this.of_1 === 4) {
          throw e;
        } else {
          this.nf_1 = this.of_1;
          this.qf_1 = e;
        }
      }
     while (true);
  }
  x37(completion) {
    var i = new initialiseExamples$slambda(completion);
    return i;
  }
}
class createAce$ace$1 {
  createRange(startRow, startColumn, endRow, endColumn) {
    return new Range(startRow, startColumn, endRow, endColumn);
  }
}
class createMonaco$monaco$1 {
  defineTheme(themeName, themeData) {
    return defineTheme(themeName, themeData);
  }
  setModelMarkers(model, owner, markers) {
    return setModelMarkers(model, owner, markers);
  }
  setModelLanguage(model, languageId) {
    return setModelLanguage(model, languageId);
  }
  setTheme(themeName) {
    return setTheme(themeName);
  }
  register(language) {
    return register(language);
  }
  setTokensProvider(languageId, provider) {
    return setTokensProvider(languageId, provider);
  }
  registerCompletionItemProvider(languageId, provider) {
    return registerCompletionItemProvider(languageId, provider);
  }
}
//endregion
var BuildConfig_instance;
function BuildConfig_getInstance() {
  if (BuildConfig_instance === VOID)
    new BuildConfig();
  return BuildConfig_instance;
}
function logAll($this, lvl, msg, t) {
  var tmp;
  switch (lvl.bc_1) {
    case 1:
      tmp = DemoLogger$consoleFatal$ref($this);
      break;
    case 2:
      tmp = DemoLogger$consoleError$ref($this);
      break;
    case 3:
      tmp = DemoLogger$consoleWarn$ref($this);
      break;
    case 4:
      tmp = DemoLogger$consoleInfo$ref($this);
      break;
    case 5:
      tmp = DemoLogger$consoleDebug$ref($this);
      break;
    case 6:
      tmp = DemoLogger$consoleTrace$ref($this);
      break;
    default:
      var tmp0_error = "Internal Error: cannot log a message to '" + lvl + "'";
      throw IllegalStateException.y1(toString(tmp0_error));
  }
  var func = tmp;
  if (null == t) {
    func(msg);
  } else {
    func(msg);
    printStackTrace(t);
  }
}
function consoleFatal($this, msg) {
  return console.error('Fatal: ' + msg);
}
function consoleError($this, msg) {
  return console.error('Error: ' + msg);
}
function consoleWarn($this, msg) {
  return console.warn('Warn: ' + msg);
}
function consoleInfo($this, msg) {
  return console.info('Info: ' + msg);
}
function consoleDebug($this, msg) {
  // Inline function 'kotlin.js.asDynamic' call
  return console.debug('Debug: ' + msg);
}
function consoleTrace($this, msg) {
  // Inline function 'kotlin.js.asDynamic' call
  return console.debug('Trace: ' + msg);
}
function DemoLogger$consoleFatal$ref($boundThis) {
  var l = function (p0) {
    consoleFatal($boundThis, p0);
    return Unit_getInstance();
  };
  l.callableName = 'consoleFatal';
  return l;
}
function DemoLogger$consoleError$ref($boundThis) {
  var l = function (p0) {
    consoleError($boundThis, p0);
    return Unit_getInstance();
  };
  l.callableName = 'consoleError';
  return l;
}
function DemoLogger$consoleWarn$ref($boundThis) {
  var l = function (p0) {
    consoleWarn($boundThis, p0);
    return Unit_getInstance();
  };
  l.callableName = 'consoleWarn';
  return l;
}
function DemoLogger$consoleInfo$ref($boundThis) {
  var l = function (p0) {
    consoleInfo($boundThis, p0);
    return Unit_getInstance();
  };
  l.callableName = 'consoleInfo';
  return l;
}
function DemoLogger$consoleDebug$ref($boundThis) {
  var l = function (p0) {
    return consoleDebug($boundThis, p0);
  };
  l.callableName = 'consoleDebug';
  return l;
}
function DemoLogger$consoleTrace$ref($boundThis) {
  var l = function (p0) {
    return consoleTrace($boundThis, p0);
  };
  l.callableName = 'consoleTrace';
  return l;
}
function get_workerScriptName() {
  _init_properties_main_kt__ykjpl3();
  return workerScriptName;
}
var workerScriptName;
function set_demo(_set____db54di) {
  _init_properties_main_kt__ykjpl3();
  demo = _set____db54di;
}
function get_demo() {
  _init_properties_main_kt__ykjpl3();
  return demo;
}
var demo;
var AlternativeEditors_ACE_instance;
var AlternativeEditors_MONACO_instance;
var AlternativeEditors_CODEMIRROR_instance;
var AlternativeEditors_AGL_instance;
function valueOf_0(value) {
  switch (value) {
    case 'ACE':
      return AlternativeEditors_ACE_getInstance();
    case 'MONACO':
      return AlternativeEditors_MONACO_getInstance();
    case 'CODEMIRROR':
      return AlternativeEditors_CODEMIRROR_getInstance();
    case 'AGL':
      return AlternativeEditors_AGL_getInstance();
    default:
      AlternativeEditors_initEntries();
      THROW_ISE();
      break;
  }
}
var AlternativeEditors_entriesInitialized;
function AlternativeEditors_initEntries() {
  if (AlternativeEditors_entriesInitialized)
    return Unit_getInstance();
  AlternativeEditors_entriesInitialized = true;
  AlternativeEditors_ACE_instance = new AlternativeEditors('ACE', 0);
  AlternativeEditors_MONACO_instance = new AlternativeEditors('MONACO', 1);
  AlternativeEditors_CODEMIRROR_instance = new AlternativeEditors('CODEMIRROR', 2);
  AlternativeEditors_AGL_instance = new AlternativeEditors('AGL', 3);
}
var Constants_instance;
function Constants_getInstance() {
  if (Constants_instance === VOID)
    new Constants();
  return Constants_instance;
}
function main() {
  _init_properties_main_kt__ykjpl3();
  try {
    var logger = new DemoLogger(LogLevel_Information_getInstance());
    var tmp0_$this = Agl_getInstance().registry;
    Constants_getInstance();
    var tmp1_identity = 'language-user';
    var tmp = Agl_getInstance();
    var tmp2_aglOptions = tmp.options(main$lambda);
    var tmp3_configuration = Agl_getInstance().configurationDefault();
    tmp0_$this.register(tmp1_identity, '', tmp2_aglOptions, false, tmp3_configuration);
    var demoIf = new main$demoIf$1(logger);
    createBaseDom('div#agl-demo', demoIf);
    var tmp_0 = ensureNotNull(document.querySelector('#agl-options-editor'));
    var editorChoice = tmp_0 instanceof HTMLSelectElement ? tmp_0 : THROW_CCE();
    editorChoice.addEventListener('change', main$lambda_0(editorChoice, logger));
    Companion_getInstance_1().d4c(document);
    initialiseExamples();
    createDemo(AlternativeEditors_ACE_getInstance(), logger);
  } catch ($p) {
    if ($p instanceof Error) {
      var t = $p;
      console.error(t);
    } else {
      throw $p;
    }
  }
}
function createBaseDom(appDivSelector, demo) {
  _init_properties_main_kt__ykjpl3();
  var appDiv = ensureNotNull(document.querySelector(appDivSelector));
  while (!(null == appDiv.firstChild)) {
    appDiv.removeChild(ensureNotNull(appDiv.firstChild));
  }
  var tmp = create(appDiv);
  tmp.article(createBaseDom$lambda(demo));
}
function initialiseExamples() {
  _init_properties_main_kt__ykjpl3();
  var tmp = CoroutineScope(SupervisorJob());
  var tmp_0 = asyncImmediately(tmp, initialiseExamples$slambda_0(null));
  tmp_0.t2r(initialiseExamples$lambda);
}
function createDemo(editorChoice, logger) {
  _init_properties_main_kt__ykjpl3();
  if (!(null == get_demo())) {
    ensureNotNull(get_demo()).z53();
  }
  var tmp = get_workerScriptName();
  // Inline function 'org.w3c.dom.WorkerOptions' call
  // Inline function 'org.w3c.dom.MODULE' call
  null;
  // Inline function 'kotlin.js.unsafeCast' call
  // Inline function 'kotlin.js.asDynamic' call
  // Inline function 'org.w3c.fetch.OMIT' call
  null;
  // Inline function 'kotlin.js.unsafeCast' call
  // Inline function 'kotlin.js.asDynamic' call
  var o = {};
  o['type'] = 'module';
  o['credentials'] = 'omit';
  var w = new SharedWorker(tmp, VOID, o);
  w.port.close();
  var editorEls = document.querySelectorAll('agl-editor');
  // Inline function 'kotlin.collections.associate' call
  var tmp4_associate = asList(editorEls);
  var capacity = coerceAtLeast(mapCapacity(collectionSizeOrDefault(tmp4_associate, 10)), 16);
  // Inline function 'kotlin.collections.associateTo' call
  var tmp0_associateTo = LinkedHashMap.o8(capacity);
  var tmp0_iterator = tmp4_associate.u();
  while (tmp0_iterator.h1()) {
    var element = tmp0_iterator.j1();
    // Inline function 'kotlin.collections.plusAssign' call
    // Inline function 'net.akehurst.language.editor.application.client.web.createDemo.<anonymous>' call
    var element_0 = element instanceof Element ? element : THROW_CCE();
    while (!(element_0.childElementCount === 0)) {
      element_0.removeChild(ensureNotNull(element_0.firstChild));
    }
    var logFunction = createDemo$lambda(logger);
    var tmp_0;
    switch (editorChoice.bc_1) {
      case 0:
        tmp_0 = createAce(element_0, logFunction);
        break;
      case 1:
        tmp_0 = createMonaco(element_0, logFunction);
        break;
      case 2:
        tmp_0 = createCodeMirror(element_0, logFunction);
        break;
      case 3:
        tmp_0 = createAgl(element_0, logFunction);
        break;
      default:
        noWhenBranchMatchedException();
        break;
    }
    var ed = tmp_0;
    var tmp0_plusAssign = new Pair(element_0.id, ed);
    tmp0_associateTo.m3(tmp0_plusAssign.ri_1, tmp0_plusAssign.si_1);
  }
  var editors = tmp0_associateTo;
  set_demo(new Demo(editors, logger));
  ensureNotNull(get_demo()).a54();
}
function createAce(editorElement, logFunction) {
  _init_properties_main_kt__ykjpl3();
  var editorId = editorElement.id;
  var languageId = ensureNotNull(editorElement.getAttribute('agl-language'));
  var tmp = new VirtualRenderer(editorElement, null);
  var tmp_0 = Ace.createEditSession('');
  // Inline function 'net.akehurst.language.editor.common.objectJS' call
  var o = {};
  // Inline function 'net.akehurst.language.editor.application.client.web.createAce.<anonymous>' call
  var ed = new Editor(tmp, tmp_0, o);
  // Inline function 'net.akehurst.language.editor.common.objectJS' call
  var o_0 = {};
  // Inline function 'net.akehurst.language.editor.application.client.web.createAce.<anonymous>' call
  // Inline function 'net.akehurst.language.editor.common.objectJS' call
  var o_1 = {};
  // Inline function 'net.akehurst.language.editor.application.client.web.createAce.<anonymous>.<anonymous>' call
  o_1.enableBasicAutocompletion = true;
  o_1.enableSnippets = true;
  o_0.editor = o_1;
  o_0.renderer = createAce$lambda;
  var aceOptions = o_0;
  ed.setOptions(aceOptions.editor);
  ed.renderer.setOptions(aceOptions.renderer);
  var tmp_1 = get_workerScriptName();
  // Inline function 'org.w3c.dom.WorkerOptions' call
  // Inline function 'org.w3c.dom.MODULE' call
  null;
  // Inline function 'kotlin.js.unsafeCast' call
  // Inline function 'kotlin.js.asDynamic' call
  // Inline function 'org.w3c.fetch.OMIT' call
  null;
  // Inline function 'kotlin.js.unsafeCast' call
  // Inline function 'kotlin.js.asDynamic' call
  var o_2 = {};
  o_2['type'] = 'module';
  o_2['credentials'] = 'omit';
  var worker = new SharedWorker(tmp_1, VOID, o_2);
  var ace = new createAce$ace$1();
  return attachToAce(Agl_getInstance(), editorElement, ed, languageId, editorId, logFunction, worker, ace);
}
function createMonaco(editorElement, logFunction) {
  _init_properties_main_kt__ykjpl3();
  var editorId = editorElement.id;
  var languageId = ensureNotNull(editorElement.getAttribute('agl-language'));
  // Inline function 'net.akehurst.language.editor.common.objectJSTyped' call
  var o = {};
  // Inline function 'net.akehurst.language.editor.application.client.web.createMonaco.<anonymous>' call
  o.value = '';
  o.wordBasedSuggestions = false;
  var editorOptions = o;
  var ed = create_0(editorElement, editorOptions, null);
  var tmp = get_workerScriptName();
  // Inline function 'org.w3c.dom.WorkerOptions' call
  // Inline function 'org.w3c.dom.MODULE' call
  null;
  // Inline function 'kotlin.js.unsafeCast' call
  // Inline function 'kotlin.js.asDynamic' call
  // Inline function 'org.w3c.fetch.OMIT' call
  null;
  // Inline function 'kotlin.js.unsafeCast' call
  // Inline function 'kotlin.js.asDynamic' call
  var o_0 = {};
  o_0['type'] = 'module';
  o_0['credentials'] = 'omit';
  var worker = new SharedWorker(tmp, VOID, o_0);
  var monaco = new createMonaco$monaco$1();
  return attachToMonaco(Agl_getInstance(), editorElement, ed, languageId, editorId, logFunction, worker, monaco);
}
function createCodeMirror(editorElement, logFunction) {
  _init_properties_main_kt__ykjpl3();
  var editorId = editorElement.id;
  var languageId = ensureNotNull(editorElement.getAttribute('agl-language'));
  // Inline function 'net.akehurst.language.editor.common.objectJSTyped' call
  var o = {};
  // Inline function 'net.akehurst.language.editor.application.client.web.createCodeMirror.<anonymous>' call
  o.doc = 'hello';
  o.parent = editorElement;
  var editorOptions = o;
  var ed = new EditorView(editorOptions);
  var tmp = get_workerScriptName();
  // Inline function 'org.w3c.dom.WorkerOptions' call
  // Inline function 'org.w3c.dom.MODULE' call
  null;
  // Inline function 'kotlin.js.unsafeCast' call
  // Inline function 'kotlin.js.asDynamic' call
  // Inline function 'org.w3c.fetch.OMIT' call
  null;
  // Inline function 'kotlin.js.unsafeCast' call
  // Inline function 'kotlin.js.asDynamic' call
  var o_0 = {};
  o_0['type'] = 'module';
  o_0['credentials'] = 'omit';
  var worker = new SharedWorker(tmp, VOID, o_0);
  return attachToCodeMirror(Agl_getInstance(), editorElement, ed, languageId, editorId, logFunction, worker);
}
function createAgl(editorElement, logFunction) {
  _init_properties_main_kt__ykjpl3();
  var editorId = editorElement.id;
  var languageId = ensureNotNull(editorElement.getAttribute('agl-language'));
  var tmp = get_workerScriptName();
  // Inline function 'org.w3c.dom.WorkerOptions' call
  // Inline function 'org.w3c.dom.MODULE' call
  null;
  // Inline function 'kotlin.js.unsafeCast' call
  // Inline function 'kotlin.js.asDynamic' call
  // Inline function 'org.w3c.fetch.OMIT' call
  null;
  // Inline function 'kotlin.js.unsafeCast' call
  // Inline function 'kotlin.js.asDynamic' call
  var o = {};
  o['type'] = 'module';
  o['credentials'] = 'omit';
  var worker = new SharedWorker(tmp, VOID, o);
  return attachToAglEditor(Agl_getInstance(), editorElement, languageId, editorId, logFunction, worker);
}
function connectEditors($this) {
  $this.w53_1.languageIdentity = Agl_getInstance().registry.agl.grammarLanguageIdentity;
  $this.x53_1.languageIdentity = Agl_getInstance().registry.agl.styleLanguageIdentity;
  $this.y53_1.languageIdentity = Agl_getInstance().registry.agl.scopesLanguageIdentity;
  Constants_getInstance();
  $this.v53_1.languageIdentity = 'language-user';
  $this.w53_1.editorSpecificStyleStr = Agl_getInstance().registry.agl.grammar.styleStr;
  $this.x53_1.editorSpecificStyleStr = Agl_getInstance().registry.agl.style.styleStr;
  $this.y53_1.editorSpecificStyleStr = Agl_getInstance().registry.agl.scopes.styleStr;
  var styleContext = new ContextFromGrammar();
  var scopeContext = new ContextFromTypeModel();
  $this.w53_1.onSemanticAnalysis(Demo$connectEditors$lambda(styleContext, scopeContext, $this));
  $this.x53_1.onSemanticAnalysis(Demo$connectEditors$lambda_0($this));
  $this.y53_1.onSemanticAnalysis(Demo$connectEditors$lambda_1($this));
}
function loading($this, parse, ast) {
  if (!(null == parse)) {
    ensureNotNull($this.t53_1.u3('parse')).q4c(parse);
  }
  if (!(null == ast)) {
    ensureNotNull($this.t53_1.u3('ast')).q4c(ast);
  }
}
function connectTrees($this) {
  var tmp = ensureNotNull($this.t53_1.u3('typemodel'));
  var tmp_0 = Demo$connectTrees$lambda;
  var tmp_1 = Demo$connectTrees$lambda_0;
  tmp.l4c_1 = new TreeViewFunctions(tmp_0, tmp_1, Demo$connectTrees$lambda_1);
  $this.w53_1.onSemanticAnalysis(Demo$connectTrees$lambda_2($this));
  var tmp_2 = ensureNotNull($this.t53_1.u3('parse'));
  var tmp_3 = Demo$connectTrees$lambda_3;
  var tmp_4 = Demo$connectTrees$lambda_4;
  tmp_2.l4c_1 = new TreeViewFunctions(tmp_3, tmp_4, Demo$connectTrees$lambda_5);
  $this.v53_1.onParse(Demo$connectTrees$lambda_6($this));
  var tmp_5 = ensureNotNull($this.t53_1.u3('ast'));
  var tmp_6 = Demo$connectTrees$lambda_7;
  var tmp_7 = Demo$connectTrees$lambda_8;
  tmp_5.l4c_1 = new TreeViewFunctions(tmp_6, tmp_7, Demo$connectTrees$lambda_9);
  $this.v53_1.onSyntaxAnalysis(Demo$connectTrees$lambda_10($this));
  $this.v53_1.onSemanticAnalysis(Demo$connectTrees$lambda_11($this));
}
function configExampleSelector($this) {
  $this.u53_1.addEventListener('change', Demo$configExampleSelector$lambda($this));
  loading($this, true, true);
  var eg = Datatypes_getInstance().o48_1;
  var tmp = $this.u53_1;
  (tmp instanceof HTMLSelectElement ? tmp : THROW_CCE()).value = eg.i47_1;
  $this.b54(eg);
}
function Demo$connectEditors$lambda($styleContext, $scopeContext, this$0) {
  return function (event) {
    var tmp0_subject = event.status;
    var tmp0 = tmp0_subject.bc_1;
    var tmp;
    switch (tmp0) {
      case 0:
        tmp = Unit_getInstance();
        break;
      case 1:
        $styleContext.clear();
        $scopeContext.clear();
        this$0.r53_1.d53(this$0.w53_1.editorId + ': ' + event.message);
        this$0.v53_1.languageDefinition.grammarStr = '';
        tmp = Unit_getInstance();
        break;
      case 2:
        $styleContext.clear();
        $scopeContext.clear();
        var tmp_0 = event.asm;
        var tmp1_elvis_lhs = (tmp_0 == null ? true : isInterface(tmp_0, List)) ? tmp_0 : THROW_CCE();
        var tmp_1;
        if (tmp1_elvis_lhs == null) {
          throw IllegalStateException.y1('should always be a List<Grammar> if success');
        } else {
          tmp_1 = tmp1_elvis_lhs;
        }

        var grammars = tmp_1;
        var firstGrammar = first(grammars);
        $styleContext.createScopeFrom(grammars);
        $scopeContext.createScopeFrom(firstGrammar.qualifiedName, TypeModelFromGrammar_getInstance().r19(firstGrammar));
        var tmp_2;
        try {
          this$0.r53_1.f53(' Grammar parse success');
          var tmp_3;
          if (this$0.s53_1) {
            this$0.r53_1.f53('resetting sentence processor');
            this$0.v53_1.languageDefinition.grammarStr = this$0.w53_1.text;
            tmp_3 = Unit_getInstance();
          }
          tmp_2 = tmp_3;
        } catch ($p) {
          var tmp_4;
          if ($p instanceof Error) {
            var t = $p;
            this$0.r53_1.e53(LogLevel_Error_getInstance(), this$0.w53_1.editorId + ': ' + t.message, t);
            this$0.v53_1.languageDefinition.grammarStr = '';
            tmp_4 = Unit_getInstance();
          } else {
            throw $p;
          }
          tmp_2 = tmp_4;
        }

        tmp = tmp_2;
        break;
    }
    this$0.y53_1.sentenceContext = $scopeContext;
    this$0.x53_1.sentenceContext = $styleContext;
    return Unit_getInstance();
  };
}
function Demo$connectEditors$lambda_0(this$0) {
  return function (event) {
    var tmp0_subject = event.status;
    var tmp0 = tmp0_subject.bc_1;
    var tmp;
    switch (tmp0) {
      case 0:
        tmp = Unit_getInstance();
        break;
      case 1:
        this$0.r53_1.d53(this$0.x53_1.editorId + ': ' + event.message);
        this$0.v53_1.languageDefinition.styleStr = '';
        tmp = Unit_getInstance();
        break;
      case 2:
        var tmp_0;
        try {
          this$0.r53_1.f53('Style parse success');
          var tmp_1;
          if (this$0.s53_1) {
            this$0.r53_1.f53('resetting sentence style');
            this$0.v53_1.languageDefinition.styleStr = this$0.x53_1.text;
            tmp_1 = Unit_getInstance();
          }
          tmp_0 = tmp_1;
        } catch ($p) {
          var tmp_2;
          if ($p instanceof Error) {
            var t = $p;
            this$0.r53_1.e53(LogLevel_Error_getInstance(), this$0.x53_1.editorId + ': ' + t.message, t);
            this$0.v53_1.languageDefinition.styleStr = '';
            tmp_2 = Unit_getInstance();
          } else {
            throw $p;
          }
          tmp_0 = tmp_2;
        }

        tmp = tmp_0;
        break;
    }
    return Unit_getInstance();
  };
}
function Demo$connectEditors$lambda_1(this$0) {
  return function (event) {
    var tmp0_subject = event.status;
    var tmp0 = tmp0_subject.bc_1;
    var tmp;
    switch (tmp0) {
      case 0:
        tmp = Unit_getInstance();
        break;
      case 1:
        this$0.r53_1.d53(this$0.y53_1.editorId + ': ' + event.message);
        tmp = Unit_getInstance();
        break;
      case 2:
        var tmp_0;
        try {
          this$0.r53_1.f53('CrossReferences SyntaxAnalysis success');
          var tmp_1;
          if (this$0.s53_1) {
            this$0.r53_1.f53('resetting scopes and references');
            this$0.v53_1.languageDefinition.scopeModelStr = this$0.y53_1.text;
            tmp_1 = Unit_getInstance();
          }
          tmp_0 = tmp_1;
        } catch ($p) {
          var tmp_2;
          if ($p instanceof Error) {
            var t = $p;
            this$0.r53_1.e53(LogLevel_Error_getInstance(), this$0.y53_1.editorId + ': ' + t.message, t);
            tmp_2 = Unit_getInstance();
          } else {
            throw $p;
          }
          tmp_0 = tmp_2;
        }

        tmp = tmp_0;
        break;
    }
    return Unit_getInstance();
  };
}
function Demo$connectTrees$lambda(root, it) {
  var tmp;
  if (!(it == null) ? typeof it === 'string' : false) {
    tmp = it;
  } else {
    if (!(it == null) ? isInterface(it, List) : false) {
      tmp = 'List';
    } else {
      if (!(it == null) ? isInterface(it, TypeModel) : false) {
        tmp = 'model ' + it.name;
      } else {
        if (!(it == null) ? isInterface(it, GrammarTypeNamespace) : false) {
          tmp = 'namespace ' + it.qualifiedName;
        } else {
          if (!(it == null) ? isInterface(it, TypeNamespace) : false) {
            tmp = 'namespace ' + it.qualifiedName;
          } else {
            if (it instanceof Pair) {
              var type = it.si_1.type;
              var ruleName = it.ri_1;
              var tmp_0;
              if (isInterface(type, DataType)) {
                var tmp_1;
                if (type.supertypes.y()) {
                  tmp_1 = ruleName + ' : ' + type.signature(type.namespace);
                } else {
                  var tmp_2 = type.signature(type.namespace);
                  var tmp_3 = type.supertypes;
                  tmp_1 = ruleName + ' : ' + tmp_2 + ' -> ' + joinToString(tmp_3, VOID, VOID, VOID, VOID, VOID, Demo$connectTrees$lambda$lambda(type));
                }
                tmp_0 = tmp_1;
              } else {
                tmp_0 = ruleName + ' : ' + type.signature(it.si_1.namespace);
              }
              tmp = tmp_0;
            } else {
              if (!(it == null) ? isInterface(it, Entry) : false) {
                var type_0 = it.p3();
                var typeName = it.o3();
                var tmp_4;
                if (isInterface(type_0, DataType)) {
                  var tmp_5;
                  if (type_0.supertypes.y()) {
                    tmp_5 = typeName + ' : ' + type_0.signature(type_0.namespace);
                  } else {
                    var tmp_6 = type_0.signature(type_0.namespace);
                    var tmp_7 = type_0.supertypes;
                    tmp_5 = typeName + ' : ' + tmp_6 + ' -> ' + joinToString(tmp_7, VOID, VOID, VOID, VOID, VOID, Demo$connectTrees$lambda$lambda_0(type_0));
                  }
                  tmp_4 = tmp_5;
                } else {
                  tmp_4 = typeName + ' : ' + type_0.signature(type_0.namespace);
                }
                tmp = tmp_4;
              } else {
                if (!(it == null) ? isInterface(it, PropertyDeclaration) : false) {
                  tmp = it.name + ' : ' + it.typeInstance.signature(it.owner.namespace, 0);
                } else {
                  var tmp0_error = 'Internal Error: type ' + getKClassFromExpression(it).n9() + ' not handled';
                  throw IllegalStateException.y1(toString(tmp0_error));
                }
              }
            }
          }
        }
      }
    }
  }
  return tmp;
}
function Demo$connectTrees$lambda$lambda($type) {
  return function (it) {
    return it.signature($type.namespace, 0);
  };
}
function Demo$connectTrees$lambda$lambda_0($type) {
  return function (it) {
    return it.signature($type.namespace, 0);
  };
}
function Demo$connectTrees$lambda_0(it) {
  var tmp;
  if (!(it == null) ? typeof it === 'string' : false) {
    tmp = false;
  } else {
    if (!(it == null) ? isInterface(it, List) : false) {
      tmp = true;
    } else {
      if (!(it == null) ? isInterface(it, TypeModel) : false) {
        // Inline function 'kotlin.collections.isNotEmpty' call
        tmp = !it.namespace.y();
      } else {
        if (!(it == null) ? isInterface(it, GrammarTypeNamespace) : false) {
          // Inline function 'kotlin.collections.isNotEmpty' call
          tmp = !it.allTypesByRuleName.y();
        } else {
          if (!(it == null) ? isInterface(it, TypeNamespace) : false) {
            // Inline function 'kotlin.collections.isNotEmpty' call
            tmp = !it.allTypesByName.y();
          } else {
            if (it instanceof Pair) {
              var type = it.si_1.type;
              var tmp_0;
              if (isInterface(type, TupleType)) {
                // Inline function 'kotlin.collections.isNotEmpty' call
                tmp_0 = !type.property.y();
              } else {
                if (isInterface(type, DataType)) {
                  // Inline function 'kotlin.collections.isNotEmpty' call
                  tmp_0 = !type.property.y();
                } else {
                  tmp_0 = false;
                }
              }
              tmp = tmp_0;
            } else {
              if (!(it == null) ? isInterface(it, Entry) : false) {
                var tmp2_subject = it.p3();
                var tmp_1;
                if (isInterface(tmp2_subject, StructuredType)) {
                  // Inline function 'kotlin.collections.isNotEmpty' call
                  var tmp_2 = it.p3();
                  tmp_1 = !(isInterface(tmp_2, StructuredType) ? tmp_2 : THROW_CCE()).property.y();
                } else {
                  tmp_1 = false;
                }
                tmp = tmp_1;
              } else {
                if (!(it == null) ? isInterface(it, PropertyDeclaration) : false) {
                  tmp = false;
                } else {
                  var tmp6_error = 'Internal Error: type ' + getKClassFromExpression(it).n9() + ' not handled';
                  throw IllegalStateException.y1(toString(tmp6_error));
                }
              }
            }
          }
        }
      }
    }
  }
  return tmp;
}
function Demo$connectTrees$lambda_1(it) {
  var tmp;
  if (!(it == null) ? typeof it === 'string' : false) {
    // Inline function 'kotlin.emptyArray' call
    tmp = [];
  } else {
    if (!(it == null) ? isInterface(it, List) : false) {
      tmp = it.toArray();
    } else {
      if (!(it == null) ? isInterface(it, TypeModel) : false) {
        // Inline function 'kotlin.collections.toTypedArray' call
        var tmp0_toTypedArray = it.allNamespace;
        tmp = copyToArray(tmp0_toTypedArray);
      } else {
        if (!(it == null) ? isInterface(it, GrammarTypeNamespace) : false) {
          // Inline function 'kotlin.collections.toTypedArray' call
          var tmp1_toTypedArray = it.allTypesByRuleName;
          tmp = copyToArray(tmp1_toTypedArray);
        } else {
          if (!(it == null) ? isInterface(it, TypeNamespace) : false) {
            // Inline function 'kotlin.collections.toTypedArray' call
            var tmp2_toTypedArray = it.allTypesByName.l3();
            tmp = copyToArray(tmp2_toTypedArray);
          } else {
            if (it instanceof Pair) {
              var type = it.si_1.type;
              var tmp_0;
              if (isInterface(type, StructuredType)) {
                // Inline function 'kotlin.collections.toTypedArray' call
                var tmp3_toTypedArray = type.property.k3();
                tmp_0 = copyToArray(tmp3_toTypedArray);
              } else {
                // Inline function 'kotlin.emptyArray' call
                tmp_0 = [];
              }
              tmp = tmp_0;
            } else {
              if (!(it == null) ? isInterface(it, Entry) : false) {
                var tmp2_subject = it.p3();
                var tmp_1;
                if (isInterface(tmp2_subject, StructuredType)) {
                  // Inline function 'kotlin.collections.toTypedArray' call
                  var tmp_2 = it.p3();
                  var tmp4_toTypedArray = (isInterface(tmp_2, StructuredType) ? tmp_2 : THROW_CCE()).property.k3();
                  tmp_1 = copyToArray(tmp4_toTypedArray);
                } else {
                  // Inline function 'kotlin.emptyArray' call
                  tmp_1 = [];
                }
                tmp = tmp_1;
              } else {
                if (!(it == null) ? isInterface(it, PropertyDeclaration) : false) {
                  // Inline function 'kotlin.emptyArray' call
                  tmp = [];
                } else {
                  var tmp5_error = 'Internal Error: type ' + getKClassFromExpression(it).n9() + ' not handled';
                  throw IllegalStateException.y1(toString(tmp5_error));
                }
              }
            }
          }
        }
      }
    }
  }
  return tmp;
}
function Demo$connectTrees$lambda_2(this$0) {
  return function (event) {
    var tmp0_subject = event.status;
    var tmp0 = tmp0_subject.bc_1;
    var tmp;
    switch (tmp0) {
      case 0:
        ensureNotNull(this$0.t53_1.u3('typemodel')).q4c(true);
        tmp = Unit_getInstance();
        break;
      case 1:
        ensureNotNull(this$0.t53_1.u3('typemodel')).q4c(false);
        tmp = Unit_getInstance();
        break;
      case 2:
        var tmp$ret$2;
        // Inline function 'kotlin.collections.map' call
        var tmp_0 = event.asm;
        var tmp0_map = (!(tmp_0 == null) ? isInterface(tmp_0, List) : false) ? tmp_0 : THROW_CCE();
        var tmp$ret$1;
        // Inline function 'kotlin.collections.mapTo' call
        var tmp0_mapTo = ArrayList.f4(collectionSizeOrDefault(tmp0_map, 10));
        var tmp0_iterator = tmp0_map.u();
        while (tmp0_iterator.h1()) {
          var item = tmp0_iterator.j1();
          var tmp$ret$0;
          // Inline function 'net.akehurst.language.editor.application.client.web.Demo.connectTrees.<anonymous>.<anonymous>' call
          tmp$ret$0 = TypeModelFromGrammar_getInstance().r19(item);
          tmp0_mapTo.e1(tmp$ret$0);
        }
        tmp$ret$1 = tmp0_mapTo;
        tmp$ret$2 = tmp$ret$1;

        var typemodels = tmp$ret$2;
        ensureNotNull(this$0.t53_1.u3('typemodel')).q4c(false);
        ensureNotNull(this$0.t53_1.u3('typemodel')).r4c(typemodels);
        tmp = Unit_getInstance();
        break;
    }
    return Unit_getInstance();
  };
}
function Demo$connectTrees$lambda_3(root, it) {
  var tmp0_subject = it.isBranch;
  var tmp;
  if (equals(tmp0_subject, false)) {
    tmp = '' + it.name + ' = ' + it.nonSkipMatchedText;
  } else if (equals(tmp0_subject, true)) {
    tmp = it.name;
  } else {
    throw IllegalStateException.y1('error');
  }
  return tmp;
}
function Demo$connectTrees$lambda_4(it) {
  return it.isBranch;
}
function Demo$connectTrees$lambda_5(it) {
  return it.children;
}
function Demo$connectTrees$lambda_6(this$0) {
  return function (event) {
    var tmp0_subject = event.status;
    var tmp0 = tmp0_subject.bc_1;
    var tmp;
    switch (tmp0) {
      case 0:
        loading(this$0, true, true);
        tmp = Unit_getInstance();
        break;
      case 1:
        loading(this$0, false, false);
        tmp = Unit_getInstance();
        break;
      case 2:
        loading(this$0, false, null);
        var tmp_0 = ensureNotNull(this$0.t53_1.u3('parse'));
        var tmp1_safe_receiver = event.tree;
        var tmp_1;
        if (tmp1_safe_receiver == null) {
          tmp_1 = null;
        } else {
          var tmp$ret$1;
          // Inline function 'kotlin.let' call
          // Inline function 'kotlin.contracts.contract' call
          var tmp$ret$0;
          // Inline function 'net.akehurst.language.editor.application.client.web.Demo.connectTrees.<anonymous>.<anonymous>' call
          tmp$ret$0 = listOf(tmp1_safe_receiver);
          tmp$ret$1 = tmp$ret$0;
          tmp_1 = tmp$ret$1;
        }

        var tmp2_elvis_lhs = tmp_1;
        tmp_0.r4c(tmp2_elvis_lhs == null ? emptyList() : tmp2_elvis_lhs);
        tmp = Unit_getInstance();
        break;
    }
    return Unit_getInstance();
  };
}
function Demo$connectTrees$lambda_7(root, it) {
  var tmp;
  if (!(it == null) ? isArray(it) : false) {
    tmp = ': Array';
  } else {
    if (!(it == null) ? isInterface(it, List) : false) {
      tmp = ': List';
    } else {
      if (!(it == null) ? isInterface(it, Set) : false) {
        tmp = ': Set';
      } else {
        if (it instanceof AsmElementSimple) {
          tmp = ': ' + it.typeName;
        } else {
          if (it instanceof AsmElementProperty) {
            var v = it.value;
            var tmp_0;
            if (null == v) {
              tmp_0 = it.name + ' = null';
            } else {
              if (!(v == null) ? isArray(v) : false) {
                tmp_0 = it.name + ' : Array';
              } else {
                if (!(v == null) ? isInterface(v, List) : false) {
                  tmp_0 = it.name + ' : List';
                } else {
                  if (!(v == null) ? isInterface(v, Set) : false) {
                    tmp_0 = it.name + ' : Set';
                  } else {
                    if (v instanceof AsmElementSimple) {
                      tmp_0 = it.name + ' : ' + v.typeName;
                    } else {
                      if (v instanceof AsmElementReference) {
                        var tmp_1;
                        if (v.value == null) {
                          tmp_1 = "&'" + v.reference + "' = <unresolved reference>";
                        } else {
                          var tmp1_safe_receiver = v.value;
                          var tmp2_safe_receiver = tmp1_safe_receiver == null ? null : tmp1_safe_receiver.asmPath;
                          var tmp_2 = tmp2_safe_receiver == null ? null : tmp2_safe_receiver.value;
                          var tmp3_safe_receiver = v.value;
                          tmp_1 = "&'" + v.reference + "' = " + tmp_2 + ' : ' + (tmp3_safe_receiver == null ? null : tmp3_safe_receiver.typeName);
                        }
                        tmp_0 = tmp_1;
                      } else {
                        if (it.name === "'" + toString_0(v) + "'") {
                          tmp_0 = it.name;
                        } else {
                          if (!(v == null) ? typeof v === 'string' : false) {
                            tmp_0 = it.name + " = '" + toString_0(v) + "'";
                          } else {
                            tmp_0 = it.name + ' = ' + toString_0(v);
                          }
                        }
                      }
                    }
                  }
                }
              }
            }
            tmp = tmp_0;
          } else {
            tmp = toString(it);
          }
        }
      }
    }
  }
  return tmp;
}
function Demo$connectTrees$lambda_8(it) {
  var tmp;
  if (!(it == null) ? isArray(it) : false) {
    tmp = true;
  } else {
    if (!(it == null) ? isInterface(it, Collection) : false) {
      tmp = true;
    } else {
      if (it instanceof AsmElementSimple) {
        tmp = !(it.properties.o() === 0);
      } else {
        if (it instanceof AsmElementProperty) {
          var v = it.value;
          var tmp_0;
          if (null == v) {
            tmp_0 = false;
          } else {
            if (!(v == null) ? isArray(v) : false) {
              tmp_0 = true;
            } else {
              if (!(v == null) ? isInterface(v, Collection) : false) {
                tmp_0 = true;
              } else {
                if (v instanceof AsmElementSimple) {
                  tmp_0 = true;
                } else {
                  tmp_0 = false;
                }
              }
            }
          }
          tmp = tmp_0;
        } else {
          tmp = false;
        }
      }
    }
  }
  return tmp;
}
function Demo$connectTrees$lambda_9(it) {
  var tmp;
  if (!(it == null) ? isArray(it) : false) {
    tmp = it;
  } else {
    if (!(it == null) ? isInterface(it, Collection) : false) {
      tmp = it.toTypedArray();
    } else {
      if (it instanceof AsmElementSimple) {
        // Inline function 'kotlin.collections.toTypedArray' call
        var tmp0_toTypedArray = it.properties.k3();
        tmp = copyToArray(tmp0_toTypedArray);
      } else {
        if (it instanceof AsmElementProperty) {
          var v = it.value;
          var tmp_0;
          if (!(v == null) ? isArray(v) : false) {
            tmp_0 = v;
          } else {
            if (!(v == null) ? isInterface(v, Collection) : false) {
              // Inline function 'kotlin.collections.toTypedArray' call
              tmp_0 = copyToArray(v);
            } else {
              if (v instanceof AsmElementSimple) {
                // Inline function 'kotlin.collections.toTypedArray' call
                var tmp2_toTypedArray = v.properties.k3();
                tmp_0 = copyToArray(tmp2_toTypedArray);
              } else {
                // Inline function 'kotlin.emptyArray' call
                tmp_0 = [];
              }
            }
          }
          tmp = tmp_0;
        } else {
          // Inline function 'kotlin.emptyArray' call
          tmp = [];
        }
      }
    }
  }
  return tmp;
}
function Demo$connectTrees$lambda_10(this$0) {
  return function (event) {
    var tmp0_subject = event.status;
    var tmp0 = tmp0_subject.bc_1;
    var tmp;
    switch (tmp0) {
      case 0:
        tmp = Unit_getInstance();
        break;
      case 1:
        this$0.r53_1.d53(event.message);
        loading(this$0, null, false);
        var tmp1_subject = event.asm;
        var tmp_0;
        if (tmp1_subject instanceof AsmSimple) {
          var tmp_1 = ensureNotNull(this$0.t53_1.u3('ast'));
          var tmp_2 = event.asm;
          tmp_1.r4c((tmp_2 instanceof AsmSimple ? tmp_2 : THROW_CCE()).rootElements);
          tmp_0 = Unit_getInstance();
        } else {
          ensureNotNull(this$0.t53_1.u3('ast')).r4c(listOf('<Unknown>'));
          tmp_0 = Unit_getInstance();
        }

        tmp = tmp_0;
        break;
      case 2:
        loading(this$0, null, false);
        var tmp2_subject = event.asm;
        var tmp_3;
        if (tmp2_subject instanceof AsmSimple) {
          var tmp_4 = ensureNotNull(this$0.t53_1.u3('ast'));
          var tmp_5 = event.asm;
          tmp_4.r4c((tmp_5 instanceof AsmSimple ? tmp_5 : THROW_CCE()).rootElements);
          tmp_3 = Unit_getInstance();
        } else {
          ensureNotNull(this$0.t53_1.u3('ast')).r4c(listOf('<Unknown>'));
          tmp_3 = Unit_getInstance();
        }

        tmp = tmp_3;
        break;
    }
    return Unit_getInstance();
  };
}
function Demo$connectTrees$lambda_11(this$0) {
  return function (event) {
    var tmp0_subject = event.status;
    var tmp0 = tmp0_subject.bc_1;
    var tmp;
    switch (tmp0) {
      case 0:
        tmp = Unit_getInstance();
        break;
      case 1:
        this$0.r53_1.d53(event.message);
        loading(this$0, null, false);
        tmp = Unit_getInstance();
        break;
      case 2:
        loading(this$0, null, false);
        var tmp1_subject = event.asm;
        var tmp_0;
        if (tmp1_subject instanceof AsmSimple) {
          var tmp_1 = ensureNotNull(this$0.t53_1.u3('ast'));
          var tmp_2 = event.asm;
          tmp_1.r4c((tmp_2 instanceof AsmSimple ? tmp_2 : THROW_CCE()).rootElements);
          tmp_0 = Unit_getInstance();
        } else {
          ensureNotNull(this$0.t53_1.u3('ast')).r4c(listOf('<Unknown>'));
          tmp_0 = Unit_getInstance();
        }

        tmp = tmp_0;
        break;
    }
    return Unit_getInstance();
  };
}
function Demo$configExampleSelector$lambda(this$0) {
  return function (_anonymous_parameter_0__qggqh8) {
    loading(this$0, true, true);
    var tmp = event.target.value;
    var egName = (!(tmp == null) ? typeof tmp === 'string' : false) ? tmp : THROW_CCE();
    var eg = Examples_getInstance().fc(egName);
    this$0.b54(eg);
    return Unit_getInstance();
  };
}
function main$lambda($this$options) {
  _init_properties_main_kt__ykjpl3();
  $this$options.semanticAnalysis(main$lambda$lambda);
  return Unit_getInstance();
}
function main$lambda$lambda($this$semanticAnalysis) {
  _init_properties_main_kt__ykjpl3();
  Companion_getInstance_0();
  $this$semanticAnalysis.option('net.akehurst.language.agl.grammar.grammar.ambiguity.analysis', false);
  return Unit_getInstance();
}
function main$lambda_0($editorChoice, $logger) {
  return function (it) {
    var optionStr = $editorChoice.value;
    var edKind = valueOf_0(optionStr);
    createDemo(edKind, $logger);
    return Unit_getInstance();
  };
}
function createBaseDom$lambda$lambda($this$header) {
  _init_properties_main_kt__ykjpl3();
  $this$header.section(createBaseDom$lambda$lambda$lambda);
  return Unit_getInstance();
}
function createBaseDom$lambda$lambda$lambda($this$section) {
  _init_properties_main_kt__ykjpl3();
  $this$section.class_.add('agl-menubar');
  $this$section.h2(createBaseDom$lambda$lambda$lambda$lambda);
  $this$section.section(createBaseDom$lambda$lambda$lambda$lambda_0);
  $this$section.nav(createBaseDom$lambda$lambda$lambda$lambda_1);
  return Unit_getInstance();
}
function createBaseDom$lambda$lambda$lambda$lambda($this$h2) {
  _init_properties_main_kt__ykjpl3();
  BuildConfig_getInstance();
  $this$h2.content = 'Version ' + '1.9.20-Beta';
  return Unit_getInstance();
}
function createBaseDom$lambda$lambda$lambda$lambda_0($this$section) {
  _init_properties_main_kt__ykjpl3();
  $this$section.class_.add('agl-options');
  $this$section.div(createBaseDom$lambda$lambda$lambda$lambda$lambda);
  return Unit_getInstance();
}
function createBaseDom$lambda$lambda$lambda$lambda$lambda($this$div) {
  _init_properties_main_kt__ykjpl3();
  $this$div.class_.add('agl-options-example');
  $this$div.label(createBaseDom$lambda$lambda$lambda$lambda$lambda$lambda);
  $this$div.select(createBaseDom$lambda$lambda$lambda$lambda$lambda$lambda_0);
  return Unit_getInstance();
}
function createBaseDom$lambda$lambda$lambda$lambda$lambda$lambda($this$label) {
  _init_properties_main_kt__ykjpl3();
  $this$label.attribute.for_ = 'example';
  $this$label.content = 'Example :';
  return Unit_getInstance();
}
function createBaseDom$lambda$lambda$lambda$lambda$lambda$lambda_0($this$select) {
  _init_properties_main_kt__ykjpl3();
  $this$select.attribute.id = 'example';
  return Unit_getInstance();
}
function createBaseDom$lambda$lambda$lambda$lambda_1($this$nav) {
  _init_properties_main_kt__ykjpl3();
  var about = $this$nav.dialog(createBaseDom$lambda$lambda$lambda$lambda$lambda_0);
  $this$nav.a(createBaseDom$lambda$lambda$lambda$lambda$lambda_1(about));
  return Unit_getInstance();
}
function createBaseDom$lambda$lambda$lambda$lambda$lambda_0($this$dialog) {
  _init_properties_main_kt__ykjpl3();
  var tmp = $this$dialog.element;
  var thisDialog = tmp instanceof HTMLDialogElement ? tmp : THROW_CCE();
  $this$dialog.on.click(createBaseDom$lambda$lambda$lambda$lambda$lambda$lambda_1(thisDialog));
  $this$dialog.article(createBaseDom$lambda$lambda$lambda$lambda$lambda$lambda_2(thisDialog));
  return Unit_getInstance();
}
function createBaseDom$lambda$lambda$lambda$lambda$lambda$lambda_1($thisDialog) {
  return function (it) {
    $thisDialog.close();
    return Unit_getInstance();
  };
}
function createBaseDom$lambda$lambda$lambda$lambda$lambda$lambda$lambda($this$header) {
  _init_properties_main_kt__ykjpl3();
  $this$header.h2(createBaseDom$lambda$lambda$lambda$lambda$lambda$lambda$lambda$lambda);
  return Unit_getInstance();
}
function createBaseDom$lambda$lambda$lambda$lambda$lambda$lambda$lambda$lambda($this$h2) {
  _init_properties_main_kt__ykjpl3();
  $this$h2.content = 'About';
  return Unit_getInstance();
}
function createBaseDom$lambda$lambda$lambda$lambda$lambda$lambda$lambda_0($this$section) {
  _init_properties_main_kt__ykjpl3();
  $this$section.p(createBaseDom$lambda$lambda$lambda$lambda$lambda$lambda$lambda$lambda_0);
  $this$section.p(createBaseDom$lambda$lambda$lambda$lambda$lambda$lambda$lambda$lambda_1);
  $this$section.p(createBaseDom$lambda$lambda$lambda$lambda$lambda$lambda$lambda$lambda_2);
  $this$section.p(createBaseDom$lambda$lambda$lambda$lambda$lambda$lambda$lambda$lambda_3);
  $this$section.h2(createBaseDom$lambda$lambda$lambda$lambda$lambda$lambda$lambda$lambda_4);
  $this$section.p(createBaseDom$lambda$lambda$lambda$lambda$lambda$lambda$lambda$lambda_5);
  $this$section.p(createBaseDom$lambda$lambda$lambda$lambda$lambda$lambda$lambda$lambda_6);
  $this$section.a(createBaseDom$lambda$lambda$lambda$lambda$lambda$lambda$lambda$lambda_7);
  return Unit_getInstance();
}
function createBaseDom$lambda$lambda$lambda$lambda$lambda$lambda$lambda$lambda_0($this$p) {
  _init_properties_main_kt__ykjpl3();
  BuildConfig_getInstance();
  $this$p.content = 'Ace version ' + '1.24.2' + ', Licence BSD';
  return Unit_getInstance();
}
function createBaseDom$lambda$lambda$lambda$lambda$lambda$lambda$lambda$lambda_1($this$p) {
  _init_properties_main_kt__ykjpl3();
  BuildConfig_getInstance();
  $this$p.content = 'Monaco version ' + '0.20.0' + ', Licence MIT';
  return Unit_getInstance();
}
function createBaseDom$lambda$lambda$lambda$lambda$lambda$lambda$lambda$lambda_2($this$p) {
  _init_properties_main_kt__ykjpl3();
  $this$p.content = 'AGL version ' + Agl_getInstance().version + ', Licence Apache 2.0';
  return Unit_getInstance();
}
function createBaseDom$lambda$lambda$lambda$lambda$lambda$lambda$lambda$lambda_3($this$p) {
  _init_properties_main_kt__ykjpl3();
  $this$p.content = 'Kotlin version ' + Companion_getInstance().el_1 + ', Licence Apache 2.0';
  return Unit_getInstance();
}
function createBaseDom$lambda$lambda$lambda$lambda$lambda$lambda$lambda$lambda_4($this$h2) {
  _init_properties_main_kt__ykjpl3();
  $this$h2.content = 'Description';
  return Unit_getInstance();
}
function createBaseDom$lambda$lambda$lambda$lambda$lambda$lambda$lambda$lambda_5($this$p) {
  _init_properties_main_kt__ykjpl3();
  $this$p.content = '                                    Functions best using Chrome.\n                                    This demo is a work in progress.\n                                    Many features are still experimental.\n                                    For ambiguous grammars, only one option is displayed in the ParseTree/AST.\n                                    Feel free to modify any of the grammars, they are all stored in the browser and will reset when you reload the page.\n                                    If something stops working, simply reload the page, and please let me know.';
  return Unit_getInstance();
}
function createBaseDom$lambda$lambda$lambda$lambda$lambda$lambda$lambda$lambda_6($this$p) {
  _init_properties_main_kt__ykjpl3();
  $this$p.content = "The 'Sentence' tab is for entering sentences in a language. The 'Language' tab is for defining the language.";
  return Unit_getInstance();
}
function createBaseDom$lambda$lambda$lambda$lambda$lambda$lambda$lambda$lambda_7($this$a) {
  _init_properties_main_kt__ykjpl3();
  $this$a.attribute.set('href', 'https://levelup.gitconnected.com/a-kotlin-multi-platform-parser-usable-from-a-jvm-or-javascript-59e870832a79');
  $this$a.content = "More documentation about the grammar syntax. (The author's personal blog post.)";
  return Unit_getInstance();
}
function createBaseDom$lambda$lambda$lambda$lambda$lambda$lambda$lambda$lambda$lambda($thisDialog) {
  return function (it) {
    $thisDialog.close();
    return Unit_getInstance();
  };
}
function createBaseDom$lambda$lambda$lambda$lambda$lambda$lambda$lambda$lambda_8($thisDialog) {
  return function ($this$button) {
    $this$button.content = 'Close';
    $this$button.on.click(createBaseDom$lambda$lambda$lambda$lambda$lambda$lambda$lambda$lambda$lambda($thisDialog));
    return Unit_getInstance();
  };
}
function createBaseDom$lambda$lambda$lambda$lambda$lambda$lambda$lambda_1($thisDialog) {
  return function ($this$footer) {
    $this$footer.button(createBaseDom$lambda$lambda$lambda$lambda$lambda$lambda$lambda$lambda_8($thisDialog));
    return Unit_getInstance();
  };
}
function createBaseDom$lambda$lambda$lambda$lambda$lambda$lambda_2($thisDialog) {
  return function ($this$article) {
    $this$article.header(createBaseDom$lambda$lambda$lambda$lambda$lambda$lambda$lambda);
    $this$article.section(createBaseDom$lambda$lambda$lambda$lambda$lambda$lambda$lambda_0);
    $this$article.footer(createBaseDom$lambda$lambda$lambda$lambda$lambda$lambda$lambda_1($thisDialog));
    return Unit_getInstance();
  };
}
function createBaseDom$lambda$lambda$lambda$lambda$lambda$lambda_3($this$h2) {
  _init_properties_main_kt__ykjpl3();
  $this$h2.content = 'About';
  return Unit_getInstance();
}
function createBaseDom$lambda$lambda$lambda$lambda$lambda$lambda_4($about) {
  return function (it) {
    ($about instanceof HTMLDialogElement ? $about : THROW_CCE()).showModal();
    return Unit_getInstance();
  };
}
function createBaseDom$lambda$lambda$lambda$lambda$lambda_1($about) {
  return function ($this$a) {
    $this$a.h2(createBaseDom$lambda$lambda$lambda$lambda$lambda$lambda_3);
    $this$a.on.click(createBaseDom$lambda$lambda$lambda$lambda$lambda$lambda_4($about));
    return Unit_getInstance();
  };
}
function createBaseDom$lambda$lambda$lambda$lambda_2($this$htmlElement) {
  _init_properties_main_kt__ykjpl3();
  $this$htmlElement.attribute.id = 'Sentence';
  $this$htmlElement.section(createBaseDom$lambda$lambda$lambda$lambda$lambda_2);
  $this$htmlElement.section(createBaseDom$lambda$lambda$lambda$lambda$lambda_3);
  return Unit_getInstance();
}
function createBaseDom$lambda$lambda$lambda$lambda$lambda_2($this$section) {
  _init_properties_main_kt__ykjpl3();
  $this$section.class_.add('sentence');
  $this$section.htmlElement('agl-editor', createBaseDom$lambda$lambda$lambda$lambda$lambda$lambda_5);
  return Unit_getInstance();
}
function createBaseDom$lambda$lambda$lambda$lambda$lambda$lambda_5($this$htmlElement) {
  _init_properties_main_kt__ykjpl3();
  Constants_getInstance();
  $this$htmlElement.attribute.id = 'editor-sentence';
  Constants_getInstance();
  $this$htmlElement.attribute.set('agl-language', 'language-user');
  return Unit_getInstance();
}
function createBaseDom$lambda$lambda$lambda$lambda$lambda_3($this$section) {
  _init_properties_main_kt__ykjpl3();
  $this$section.class_.add('trees');
  $this$section.htmlElement('tabview', createBaseDom$lambda$lambda$lambda$lambda$lambda$lambda_6);
  return Unit_getInstance();
}
function createBaseDom$lambda$lambda$lambda$lambda$lambda$lambda_6($this$htmlElement) {
  _init_properties_main_kt__ykjpl3();
  $this$htmlElement.htmlElement('tab', createBaseDom$lambda$lambda$lambda$lambda$lambda$lambda$lambda_2);
  $this$htmlElement.htmlElement('tab', createBaseDom$lambda$lambda$lambda$lambda$lambda$lambda$lambda_3);
  return Unit_getInstance();
}
function createBaseDom$lambda$lambda$lambda$lambda$lambda$lambda$lambda_2($this$htmlElement) {
  _init_properties_main_kt__ykjpl3();
  $this$htmlElement.attribute.id = 'ParseTree';
  $this$htmlElement.htmlElement('treeview', createBaseDom$lambda$lambda$lambda$lambda$lambda$lambda$lambda$lambda_9);
  return Unit_getInstance();
}
function createBaseDom$lambda$lambda$lambda$lambda$lambda$lambda$lambda$lambda_9($this$htmlElement) {
  _init_properties_main_kt__ykjpl3();
  $this$htmlElement.attribute.id = 'parse';
  return Unit_getInstance();
}
function createBaseDom$lambda$lambda$lambda$lambda$lambda$lambda$lambda_3($this$htmlElement) {
  _init_properties_main_kt__ykjpl3();
  $this$htmlElement.attribute.id = 'AST';
  $this$htmlElement.htmlElement('treeview', createBaseDom$lambda$lambda$lambda$lambda$lambda$lambda$lambda$lambda_10);
  return Unit_getInstance();
}
function createBaseDom$lambda$lambda$lambda$lambda$lambda$lambda$lambda$lambda_10($this$htmlElement) {
  _init_properties_main_kt__ykjpl3();
  $this$htmlElement.attribute.id = 'ast';
  return Unit_getInstance();
}
function createBaseDom$lambda$lambda$lambda$lambda_3($this$htmlElement) {
  _init_properties_main_kt__ykjpl3();
  $this$htmlElement.attribute.id = 'Language';
  $this$htmlElement.section(createBaseDom$lambda$lambda$lambda$lambda$lambda_4);
  return Unit_getInstance();
}
function createBaseDom$lambda$lambda$lambda$lambda$lambda_4($this$section) {
  _init_properties_main_kt__ykjpl3();
  $this$section.class_.add('language');
  $this$section.htmlElement('tabview', createBaseDom$lambda$lambda$lambda$lambda$lambda$lambda_7);
  return Unit_getInstance();
}
function createBaseDom$lambda$lambda$lambda$lambda$lambda$lambda_7($this$htmlElement) {
  _init_properties_main_kt__ykjpl3();
  $this$htmlElement.htmlElement('tab', createBaseDom$lambda$lambda$lambda$lambda$lambda$lambda$lambda_4);
  $this$htmlElement.htmlElement('tab', createBaseDom$lambda$lambda$lambda$lambda$lambda$lambda$lambda_5);
  $this$htmlElement.htmlElement('tab', createBaseDom$lambda$lambda$lambda$lambda$lambda$lambda$lambda_6);
  return Unit_getInstance();
}
function createBaseDom$lambda$lambda$lambda$lambda$lambda$lambda$lambda_4($this$htmlElement) {
  _init_properties_main_kt__ykjpl3();
  $this$htmlElement.attribute.id = 'Grammar';
  $this$htmlElement.section(createBaseDom$lambda$lambda$lambda$lambda$lambda$lambda$lambda$lambda_11);
  $this$htmlElement.article(createBaseDom$lambda$lambda$lambda$lambda$lambda$lambda$lambda$lambda_12);
  return Unit_getInstance();
}
function createBaseDom$lambda$lambda$lambda$lambda$lambda$lambda$lambda$lambda_11($this$section) {
  _init_properties_main_kt__ykjpl3();
  $this$section.class_.add('grammar');
  $this$section.htmlElement('agl-editor', createBaseDom$lambda$lambda$lambda$lambda$lambda$lambda$lambda$lambda$lambda_0);
  return Unit_getInstance();
}
function createBaseDom$lambda$lambda$lambda$lambda$lambda$lambda$lambda$lambda$lambda_0($this$htmlElement) {
  _init_properties_main_kt__ykjpl3();
  Constants_getInstance();
  $this$htmlElement.attribute.id = 'editor-grammar';
  $this$htmlElement.attribute.set('agl-language', Constants_getInstance().m53_1);
  return Unit_getInstance();
}
function createBaseDom$lambda$lambda$lambda$lambda$lambda$lambda$lambda$lambda_12($this$article) {
  _init_properties_main_kt__ykjpl3();
  $this$article.class_.add('typemodel');
  $this$article.header(createBaseDom$lambda$lambda$lambda$lambda$lambda$lambda$lambda$lambda$lambda_1);
  $this$article.section(createBaseDom$lambda$lambda$lambda$lambda$lambda$lambda$lambda$lambda$lambda_2);
  return Unit_getInstance();
}
function createBaseDom$lambda$lambda$lambda$lambda$lambda$lambda$lambda$lambda$lambda_1($this$header) {
  _init_properties_main_kt__ykjpl3();
  $this$header.h3(createBaseDom$lambda$lambda$lambda$lambda$lambda$lambda$lambda$lambda$lambda$lambda);
  return Unit_getInstance();
}
function createBaseDom$lambda$lambda$lambda$lambda$lambda$lambda$lambda$lambda$lambda$lambda($this$h3) {
  _init_properties_main_kt__ykjpl3();
  $this$h3.content = 'Type Model';
  return Unit_getInstance();
}
function createBaseDom$lambda$lambda$lambda$lambda$lambda$lambda$lambda$lambda$lambda_2($this$section) {
  _init_properties_main_kt__ykjpl3();
  $this$section.htmlElement('treeview', createBaseDom$lambda$lambda$lambda$lambda$lambda$lambda$lambda$lambda$lambda$lambda_0);
  return Unit_getInstance();
}
function createBaseDom$lambda$lambda$lambda$lambda$lambda$lambda$lambda$lambda$lambda$lambda_0($this$htmlElement) {
  _init_properties_main_kt__ykjpl3();
  $this$htmlElement.attribute.id = 'typemodel';
  return Unit_getInstance();
}
function createBaseDom$lambda$lambda$lambda$lambda$lambda$lambda$lambda_5($this$htmlElement) {
  _init_properties_main_kt__ykjpl3();
  $this$htmlElement.attribute.id = 'style';
  $this$htmlElement.section(createBaseDom$lambda$lambda$lambda$lambda$lambda$lambda$lambda$lambda_13);
  return Unit_getInstance();
}
function createBaseDom$lambda$lambda$lambda$lambda$lambda$lambda$lambda$lambda_13($this$section) {
  _init_properties_main_kt__ykjpl3();
  $this$section.htmlElement('agl-editor', createBaseDom$lambda$lambda$lambda$lambda$lambda$lambda$lambda$lambda$lambda_3);
  return Unit_getInstance();
}
function createBaseDom$lambda$lambda$lambda$lambda$lambda$lambda$lambda$lambda$lambda_3($this$htmlElement) {
  _init_properties_main_kt__ykjpl3();
  Constants_getInstance();
  $this$htmlElement.attribute.id = 'editor-style';
  $this$htmlElement.attribute.set('agl-language', Constants_getInstance().o53_1);
  return Unit_getInstance();
}
function createBaseDom$lambda$lambda$lambda$lambda$lambda$lambda$lambda_6($this$htmlElement) {
  _init_properties_main_kt__ykjpl3();
  $this$htmlElement.attribute.id = 'crossreferences';
  $this$htmlElement.section(createBaseDom$lambda$lambda$lambda$lambda$lambda$lambda$lambda$lambda_14);
  return Unit_getInstance();
}
function createBaseDom$lambda$lambda$lambda$lambda$lambda$lambda$lambda$lambda_14($this$section) {
  _init_properties_main_kt__ykjpl3();
  $this$section.htmlElement('agl-editor', createBaseDom$lambda$lambda$lambda$lambda$lambda$lambda$lambda$lambda$lambda_4);
  return Unit_getInstance();
}
function createBaseDom$lambda$lambda$lambda$lambda$lambda$lambda$lambda$lambda$lambda_4($this$htmlElement) {
  _init_properties_main_kt__ykjpl3();
  Constants_getInstance();
  $this$htmlElement.attribute.id = 'editor-references';
  $this$htmlElement.attribute.set('agl-language', Constants_getInstance().n53_1);
  return Unit_getInstance();
}
function createBaseDom$lambda$lambda$lambda$lambda$lambda$lambda$lambda_7($this$header) {
  _init_properties_main_kt__ykjpl3();
  $this$header.h3(createBaseDom$lambda$lambda$lambda$lambda$lambda$lambda$lambda$lambda_15);
  return Unit_getInstance();
}
function createBaseDom$lambda$lambda$lambda$lambda$lambda$lambda$lambda$lambda_15($this$h3) {
  _init_properties_main_kt__ykjpl3();
  $this$h3.content = 'Demo';
  return Unit_getInstance();
}
function createBaseDom$lambda$lambda$lambda$lambda$lambda$lambda$lambda$lambda$lambda_5($this$label) {
  _init_properties_main_kt__ykjpl3();
  $this$label.content = 'Select Logging Level: ';
  return Unit_getInstance();
}
function createBaseDom$lambda$lambda$lambda$lambda$lambda$lambda$lambda$lambda$lambda$lambda_1($this$option) {
  _init_properties_main_kt__ykjpl3();
  $this$option.content = LogLevel_None_getInstance().ac_1;
  return Unit_getInstance();
}
function createBaseDom$lambda$lambda$lambda$lambda$lambda$lambda$lambda$lambda$lambda$lambda_2($this$option) {
  _init_properties_main_kt__ykjpl3();
  $this$option.content = LogLevel_Fatal_getInstance().ac_1;
  return Unit_getInstance();
}
function createBaseDom$lambda$lambda$lambda$lambda$lambda$lambda$lambda$lambda$lambda$lambda_3($this$option) {
  _init_properties_main_kt__ykjpl3();
  $this$option.content = LogLevel_Error_getInstance().ac_1;
  return Unit_getInstance();
}
function createBaseDom$lambda$lambda$lambda$lambda$lambda$lambda$lambda$lambda$lambda$lambda_4($this$option) {
  _init_properties_main_kt__ykjpl3();
  $this$option.content = LogLevel_Warning_getInstance().ac_1;
  return Unit_getInstance();
}
function createBaseDom$lambda$lambda$lambda$lambda$lambda$lambda$lambda$lambda$lambda$lambda_5($this$option) {
  _init_properties_main_kt__ykjpl3();
  $this$option.content = LogLevel_Information_getInstance().ac_1;
  return Unit_getInstance();
}
function createBaseDom$lambda$lambda$lambda$lambda$lambda$lambda$lambda$lambda$lambda$lambda_6($this$option) {
  _init_properties_main_kt__ykjpl3();
  $this$option.content = LogLevel_Debug_getInstance().ac_1;
  return Unit_getInstance();
}
function createBaseDom$lambda$lambda$lambda$lambda$lambda$lambda$lambda$lambda$lambda$lambda_7($this$option) {
  _init_properties_main_kt__ykjpl3();
  $this$option.content = LogLevel_Trace_getInstance().ac_1;
  return Unit_getInstance();
}
function createBaseDom$lambda$lambda$lambda$lambda$lambda$lambda$lambda$lambda$lambda$lambda_8($this$option) {
  _init_properties_main_kt__ykjpl3();
  $this$option.content = LogLevel_All_getInstance().ac_1;
  return Unit_getInstance();
}
function createBaseDom$lambda$lambda$lambda$lambda$lambda$lambda$lambda$lambda$lambda_6($demo) {
  return function ($this$select) {
    $this$select.attribute.id = 'agl-demo-logging-level';
    var tmp0_value = LogLevel_None_getInstance().ac_1;
    var tmp1_selected = $demo.d54().equals(LogLevel_None_getInstance());
    $this$select.option(VOID, VOID, tmp1_selected, tmp0_value, createBaseDom$lambda$lambda$lambda$lambda$lambda$lambda$lambda$lambda$lambda$lambda_1);
    var tmp2_value = LogLevel_Fatal_getInstance().ac_1;
    var tmp3_selected = $demo.d54().equals(LogLevel_Fatal_getInstance());
    $this$select.option(VOID, VOID, tmp3_selected, tmp2_value, createBaseDom$lambda$lambda$lambda$lambda$lambda$lambda$lambda$lambda$lambda$lambda_2);
    var tmp4_value = LogLevel_Error_getInstance().ac_1;
    var tmp5_selected = $demo.d54().equals(LogLevel_Error_getInstance());
    $this$select.option(VOID, VOID, tmp5_selected, tmp4_value, createBaseDom$lambda$lambda$lambda$lambda$lambda$lambda$lambda$lambda$lambda$lambda_3);
    var tmp6_value = LogLevel_Warning_getInstance().ac_1;
    var tmp7_selected = $demo.d54().equals(LogLevel_Warning_getInstance());
    $this$select.option(VOID, VOID, tmp7_selected, tmp6_value, createBaseDom$lambda$lambda$lambda$lambda$lambda$lambda$lambda$lambda$lambda$lambda_4);
    var tmp8_value = LogLevel_Information_getInstance().ac_1;
    var tmp9_selected = $demo.d54().equals(LogLevel_Information_getInstance());
    $this$select.option(VOID, VOID, tmp9_selected, tmp8_value, createBaseDom$lambda$lambda$lambda$lambda$lambda$lambda$lambda$lambda$lambda$lambda_5);
    var tmp10_value = LogLevel_Debug_getInstance().ac_1;
    var tmp11_selected = $demo.d54().equals(LogLevel_Debug_getInstance());
    $this$select.option(VOID, VOID, tmp11_selected, tmp10_value, createBaseDom$lambda$lambda$lambda$lambda$lambda$lambda$lambda$lambda$lambda$lambda_6);
    var tmp12_value = LogLevel_Trace_getInstance().ac_1;
    var tmp13_selected = $demo.d54().equals(LogLevel_Trace_getInstance());
    $this$select.option(VOID, VOID, tmp13_selected, tmp12_value, createBaseDom$lambda$lambda$lambda$lambda$lambda$lambda$lambda$lambda$lambda$lambda_7);
    var tmp14_value = LogLevel_All_getInstance().ac_1;
    var tmp15_selected = $demo.d54().equals(LogLevel_All_getInstance());
    $this$select.option(VOID, VOID, tmp15_selected, tmp14_value, createBaseDom$lambda$lambda$lambda$lambda$lambda$lambda$lambda$lambda$lambda$lambda_8);
    return Unit_getInstance();
  };
}
function createBaseDom$lambda$lambda$lambda$lambda$lambda$lambda$lambda$lambda$lambda_7($tmp0_also, $demo) {
  return function (it) {
    var optionStr = $tmp0_also.value;
    var ll = valueOf(optionStr);
    $demo.e54(ll);
    return Unit_getInstance();
  };
}
function createBaseDom$lambda$lambda$lambda$lambda$lambda$lambda$lambda$lambda_16($demo) {
  return function ($this$div) {
    $this$div.label(createBaseDom$lambda$lambda$lambda$lambda$lambda$lambda$lambda$lambda$lambda_5);
    var tmp$ret$0;
    // Inline function 'kotlin.also' call
    var tmp0_also = $this$div.select(createBaseDom$lambda$lambda$lambda$lambda$lambda$lambda$lambda$lambda$lambda_6($demo));
    // Inline function 'kotlin.contracts.contract' call
    // Inline function 'net.akehurst.language.editor.application.client.web.createBaseDom.<anonymous>.<anonymous>.<anonymous>.<anonymous>.<anonymous>.<anonymous>.<anonymous>.<anonymous>.<anonymous>' call
    var tmp = tmp0_also instanceof HTMLSelectElement ? tmp0_also : THROW_CCE();
    tmp.addEventListener('change', createBaseDom$lambda$lambda$lambda$lambda$lambda$lambda$lambda$lambda$lambda_7(tmp0_also, $demo));
    tmp$ret$0 = tmp0_also;
    return Unit_getInstance();
  };
}
function createBaseDom$lambda$lambda$lambda$lambda$lambda$lambda$lambda$lambda_17($this$div) {
  _init_properties_main_kt__ykjpl3();
  $this$div.label(createBaseDom$lambda$lambda$lambda$lambda$lambda$lambda$lambda$lambda$lambda_8);
  $this$div.select(createBaseDom$lambda$lambda$lambda$lambda$lambda$lambda$lambda$lambda$lambda_9);
  return Unit_getInstance();
}
function createBaseDom$lambda$lambda$lambda$lambda$lambda$lambda$lambda$lambda$lambda_8($this$label) {
  _init_properties_main_kt__ykjpl3();
  $this$label.content = 'Select underlying Editor Type: ';
  return Unit_getInstance();
}
function createBaseDom$lambda$lambda$lambda$lambda$lambda$lambda$lambda$lambda$lambda_9($this$select) {
  _init_properties_main_kt__ykjpl3();
  $this$select.attribute.id = 'agl-options-editor';
  var tmp0_value = AlternativeEditors_ACE_getInstance().ac_1;
  $this$select.option(VOID, VOID, true, tmp0_value, createBaseDom$lambda$lambda$lambda$lambda$lambda$lambda$lambda$lambda$lambda$lambda_9);
  return Unit_getInstance();
}
function createBaseDom$lambda$lambda$lambda$lambda$lambda$lambda$lambda$lambda$lambda$lambda_9($this$option) {
  _init_properties_main_kt__ykjpl3();
  $this$option.content = 'Ace';
  return Unit_getInstance();
}
function createBaseDom$lambda$lambda$lambda$lambda$lambda$lambda$lambda_8($demo) {
  return function ($this$section) {
    $this$section.class_.add('configuration');
    $this$section.div(createBaseDom$lambda$lambda$lambda$lambda$lambda$lambda$lambda$lambda_16($demo));
    $this$section.div(createBaseDom$lambda$lambda$lambda$lambda$lambda$lambda$lambda$lambda_17);
    return Unit_getInstance();
  };
}
function createBaseDom$lambda$lambda$lambda$lambda$lambda$lambda_8($demo) {
  return function ($this$article) {
    $this$article.header(createBaseDom$lambda$lambda$lambda$lambda$lambda$lambda$lambda_7);
    $this$article.section(createBaseDom$lambda$lambda$lambda$lambda$lambda$lambda$lambda_8($demo));
    return Unit_getInstance();
  };
}
function createBaseDom$lambda$lambda$lambda$lambda$lambda_5($demo) {
  return function ($this$div) {
    $this$div.article(createBaseDom$lambda$lambda$lambda$lambda$lambda$lambda_8($demo));
    return Unit_getInstance();
  };
}
function createBaseDom$lambda$lambda$lambda$lambda_4($demo) {
  return function ($this$htmlElement) {
    $this$htmlElement.attribute.id = 'Configuration';
    $this$htmlElement.div(createBaseDom$lambda$lambda$lambda$lambda$lambda_5($demo));
    return Unit_getInstance();
  };
}
function createBaseDom$lambda$lambda$lambda_0($demo) {
  return function ($this$htmlElement) {
    $this$htmlElement.htmlElement('tab', createBaseDom$lambda$lambda$lambda$lambda_2);
    $this$htmlElement.htmlElement('tab', createBaseDom$lambda$lambda$lambda$lambda_3);
    $this$htmlElement.htmlElement('tab', createBaseDom$lambda$lambda$lambda$lambda_4($demo));
    return Unit_getInstance();
  };
}
function createBaseDom$lambda$lambda_0($demo) {
  return function ($this$section) {
    $this$section.htmlElement('tabview', createBaseDom$lambda$lambda$lambda_0($demo));
    return Unit_getInstance();
  };
}
function createBaseDom$lambda($demo) {
  return function ($this$article) {
    $this$article.header(createBaseDom$lambda$lambda);
    $this$article.section(createBaseDom$lambda$lambda_0($demo));
    return Unit_getInstance();
  };
}
function initialiseExamples$slambda_0(resultContinuation) {
  var i = new initialiseExamples$slambda(resultContinuation);
  var l = function ($completion) {
    return i.r38($completion);
  };
  l.$arity = 0;
  return l;
}
function initialiseExamples$lambda(it) {
  _init_properties_main_kt__ykjpl3();
  var tmp = document.querySelector('select#example');
  var exampleSelect = tmp instanceof HTMLElement ? tmp : THROW_CCE();
  // Inline function 'kotlin.collections.forEach' call
  // Inline function 'kotlin.collections.iterator' call
  var tmp0_iterator = Examples_getInstance().p47_1.l3().u();
  while (tmp0_iterator.h1()) {
    var element = tmp0_iterator.j1();
    // Inline function 'net.akehurst.language.editor.application.client.web.initialiseExamples.<anonymous>.<anonymous>' call
    var option = document.createElement('option');
    exampleSelect.appendChild(option);
    option.setAttribute('value', element.p3().i47_1);
    option.textContent = element.p3().j47_1;
  }
  return Unit_getInstance();
}
function createDemo$lambda($logger) {
  return function (lvl, msg, t) {
    $logger.e53(lvl, msg, t);
    return Unit_getInstance();
  };
}
function createAce$lambda() {
  _init_properties_main_kt__ykjpl3();
  return Unit_getInstance();
}
function AlternativeEditors_ACE_getInstance() {
  AlternativeEditors_initEntries();
  return AlternativeEditors_ACE_instance;
}
function AlternativeEditors_MONACO_getInstance() {
  AlternativeEditors_initEntries();
  return AlternativeEditors_MONACO_instance;
}
function AlternativeEditors_CODEMIRROR_getInstance() {
  AlternativeEditors_initEntries();
  return AlternativeEditors_CODEMIRROR_instance;
}
function AlternativeEditors_AGL_getInstance() {
  AlternativeEditors_initEntries();
  return AlternativeEditors_AGL_instance;
}
var properties_initialized_main_kt_ask6ij;
function _init_properties_main_kt__ykjpl3() {
  if (!properties_initialized_main_kt_ask6ij) {
    properties_initialized_main_kt_ask6ij = true;
    workerScriptName = aglScriptBasePath + '/application-agl-editor-worker.js';
    demo = null;
  }
}
//region block: post-declaration
setMetadataFor(BuildConfig, 'BuildConfig', objectMeta);
setMetadataFor(DemoLogger, 'DemoLogger', classMeta);
setMetadataFor(AlternativeEditors, 'AlternativeEditors', classMeta);
setMetadataFor(Constants, 'Constants', objectMeta);
setMetadataFor(Demo, 'Demo', classMeta);
setMetadataFor(main$demoIf$1, VOID, classMeta);
setMetadataFor(initialiseExamples$slambda, 'initialiseExamples$slambda', classMeta, VOID, VOID, VOID, VOID, [0]);
setMetadataFor(createAce$ace$1, VOID, classMeta, VOID, [IAce]);
setMetadataFor(createMonaco$monaco$1, VOID, classMeta, VOID, [Monaco]);
//endregion
main();

//# sourceMappingURL=net.akehurst.language.editor.browser.demo-application-client-web.mjs.map
